import '../styles/style.scss'
import './utils/polyfills'
import './utils/detectTouch'
import './utils/responsiveHelper'
import ResizeHandler from './utils/resize-active'

import 'intersection-observer' // Polyfill IntersectionObserver API for IE and old Safari
import LazyLoad from 'vanilla-lazyload' // Lazy load images plugin
import initMobileNav from './components/mobileNav'
import initHeadroom from './components/headroom'
import initFixedHeader from './components/fixedHeader'
import swiperGalleryInit from './components/swiperGalleryInit'
import initFancybox from './components/fancyboxInit'
import aosInit from './components/aosInit'
import initGoogleMap from './components/initGoogleMap'
import anchorLinkHolder from './components/anchorLinkHolder'
import initCloneTableHeader from './components/initCloneTableHeader'
import initInputRange from './components/initInputRange'
import initStickyScrollBlock from './components/initStickyScrollBlock'
import initTableFilter from './components/initTableFilter'
import initOpenClose from './components/openCloseInit'
import initSvgShape from './components/svgShape'

const resizeHandler = new ResizeHandler()

/** Load Events */
window.addEventListener('DOMContentLoaded', () => {
  /**
   * Init lazyload and polyfill
   */
  const lazyLoadInsance = new LazyLoad()
  lazyLoadInsance.update()
  resizeHandler.init()
  initMobileNav()
  initHeadroom()
  initFixedHeader()
  swiperGalleryInit()
  initFancybox()
  aosInit()
  initGoogleMap()
  anchorLinkHolder()
  initCloneTableHeader()
  initStickyScrollBlock()
  initTableFilter()
  initInputRange()
  initOpenClose()
})

window.addEventListener('load', () => {
  initSvgShape()
});